/**
 * Стилі react-select як у таблиці PR+ (HeaderControls) — єдиний вигляд для всіх майбутніх Select.
 */
export const prTableSelectStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: "#fff",
        border: "1px solid #000",
        borderRadius: "8px",
        boxShadow: "none",
        minHeight: "38px",
        cursor: "pointer",
        "&:hover": {
            borderColor: "#000",
        },
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: "#fff",
        border: "1px solid #000",
        borderRadius: "6px",
        padding: "2px 4px",
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: "#000",
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: "#000",
        ":hover": {
            backgroundColor: "#000",
            color: "#fff",
        },
    }),
    placeholder: (base) => ({
        ...base,
        color: "#666",
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#000",
        padding: "4px",
        ":hover": {
            color: "#000",
        },
    }),
    menu: (base) => ({
        ...base,
        border: "1px solid #000",
        borderRadius: "8px",
        zIndex: 9999,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#000" : "#fff",
        color: state.isSelected ? "#fff" : "#000",
        ":hover": {
            backgroundColor: "#f1f1f1",
            color: "#000",
        },
    }),
};
